<template>
  <div v-if="showHelp" class="help-menu">
    <component v-if="helpComponent" :is="helpComponent" :key="helpType" />
  </div>
</template>

<script>
import RoofHelp from '@/components/help/roof';

export default {
  data: () => ({}),
  computed: {
    showHelp() {
      return this.$store.getters['help/getShow'];
    },
    helpType() {
      return this.$store.getters['help/getType'];
    },
    helpComponent() {
      switch (this.helpType) {
        case 'roof':
          return RoofHelp;
        default:
          return null;
      }
    },
  },
  methods: {},
};
</script>

<style lang="stylus" scoped></style>
